import { Box } from '@chakra-ui/react';
import { modalDetailWarehouseText } from 'Const/stock-promo/view';
import { TextBold } from 'UiKit/typography';
import Tooltip from 'UiKit/tooltip';

import { AlertOutlineIcon } from 'Asset/icon';

import styles from './styles.module.css';

const tableList = [
  {
    name: modalDetailWarehouseText.colWarehouseText,
    key: 'storage',
    width: '70%',
    position: 'left',
    component: ({ value }) => {
      const isActive = value?.status === 'Aktif';
      const background = isActive ? '#e7f1ff' : '#f1f1f1;';
      const color = isActive ? ' var(--color-primary70);' : 'var(--color-semantic-text)';

      return (
        <Box background={background} className={`${styles['table__cell--warehouse']}`} color={color}>
          {value?.name}
        </Box>
      );
    },
  },
  {
    name: modalDetailWarehouseText.colStockText,
    key: 'availableStock',
    width: '30%',
    position: 'left',

    customizeTableHead: (
      <Box className={styles['stock__table--head']}>
        <TextBold className={styles['title__text']}>{modalDetailWarehouseText.colStockText}</TextBold>

        <Tooltip className={styles['stock__tooltip']} width="max-content" label={modalDetailWarehouseText.colStockTooltipText}>
          <AlertOutlineIcon size="16px" color="var(--color-neutral40)" />
        </Tooltip>
      </Box>
    ),
    component: ({ value }) => {
      return <Box className={styles['table__cell--stock']}>{value}</Box>;
    },
  },
];
export default tableList;
